import React, { useCallback, useEffect, useState } from "react";
import { MessageCircle, Trash2, Send } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

/** Workgroup discussion on one saved check; refreshes every 10 s so the group sees new comments. */
export function CommentsPanel({ targetType, targetId }) {
  const { user } = useAuth();
  const [items, setItems] = useState([]);
  const [text, setText] = useState("");
  const load = useCallback(() => api.listComments(targetType, targetId).then(setItems).catch((e) => console.warn("comments load failed", e)), [targetType, targetId]);
  useEffect(() => {
    load();
    const t = setInterval(load, 10000);
    return () => clearInterval(t);
  }, [load]);
  const send = async () => {
    await api.addComment({ target_type: targetType, target_id: targetId, text });
    setText("");
    load();
  };
  const remove = async (id) => {
    await api.deleteComment(id);
    load();
  };
  return (
    <Card data-testid="comments-panel">
      <CardContent className="p-4 space-y-3">
        <h3 className="font-semibold flex items-center gap-2"><MessageCircle className="w-4 h-4 text-cyan-400" /> Workgroup discussion ({items.length})</h3>
        {items.map((c) => (
          <div key={c.id} className="rounded border border-border bg-background/40 p-2 text-sm" data-testid={`comment-${c.id}`}>
            <div className="flex items-center gap-2 text-xs text-muted-foreground mb-1">
              <span className="font-medium text-foreground">{c.author?.name || "Unknown"}</span>
              <span>{new Date(c.created_at).toLocaleString()}</span>
              {(user?.role === "admin" || c.author?.id === user?.id) && (
                <button type="button" className="ml-auto hover:text-rose-300" onClick={() => remove(c.id)} data-testid={`comment-delete-${c.id}`}><Trash2 className="w-3.5 h-3.5" /></button>
              )}
            </div>
            <p className="whitespace-pre-wrap">{c.text}</p>
          </div>
        ))}
        <div className="flex gap-2 items-start">
          <Textarea value={text} onChange={(e) => setText(e.target.value)} placeholder="Add a comment for the workgroup…" className="min-h-[60px] text-sm" data-testid="comment-input" />
          <Button onClick={send} disabled={!text.trim()} data-testid="comment-send-btn"><Send className="w-4 h-4" /></Button>
        </div>
      </CardContent>
    </Card>
  );
}
